
export const newDialog = options => {

    !options.classList && (options.classList = "")

    const dialogWrapper = document.createElement('div');
    dialogWrapper.classList.add('dialog-wrapper');
    options.classList && dialogWrapper.classList.add(options.classList);
    dialogWrapper.innerHTML = `<div class="dialog-content">${options.body}</div>`

    document.body.appendChild(dialogWrapper)

    if (options.callback) {
        options.callback(dialogWrapper)
    }

}